export default "__VITE_ASSET__MjbEmDn4__"